<template>
  <div>
    <!-- Loading State -->
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px;"
    >
      <b-spinner class="align-middle mr-2" />
      <strong>Lade Benutzerdaten...</strong>
    </div>

    <!-- Error State -->
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      <feather-icon
        icon="AlertTriangleIcon"
        class="mr-1"
      />
      {{ error }}
    </div>

    <!-- User Not Found -->
    <div
      v-else-if="!userById"
      class="text-center py-5"
    >
      <feather-icon
        icon="UserXIcon"
        size="64"
        class="text-muted mb-3"
      />
      <h4 class="text-muted">
        Benutzer nicht gefunden
      </h4>
      <p class="text-muted">
        Der angeforderte Benutzer konnte nicht gefunden werden.
      </p>
      <b-button
        variant="primary"
        @click="$router.push('/user-list')"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="14"
          class="mr-50"
        />
        Zurück zur Benutzerliste
      </b-button>
    </div>

    <!-- Main Content -->
    <template v-else>

      <!-- Main Content Layout -->
      <b-row class="match-height">
        <!-- Left Column - User Information -->
        <b-col
          xl="8"
          lg="12"
          md="12"
        >
          <b-row class="match-height">
            <!-- Personal Information Card -->
            <b-col
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <user-view-info-card-part-one
                :user="userById"
                @edit-user="editUser"
                @toggle-block="toggleBlockStatus"
              />
            </b-col>

            <!-- Role & Permissions Card -->
            <b-col
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <user-view-info-card-part-two
                :user="userById"
                @edit-permissions="editPermissions"
                @view-role-details="viewRoleDetails"
                @view-audit-log="viewAuditLog"
              />
            </b-col>

            <!-- Statistics Card -->
            <b-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
            >
              <user-view-statistics :user="userById" />
            </b-col>
          </b-row>
        </b-col>

        <!-- Right Column - Activity Timeline -->
        <b-col
          xl="4"
          lg="12"
          md="12"
        >
          <user-view-activity-timeline
            :user="userById"
            @view-full-history="viewFullHistory"
          />
        </b-col>
      </b-row>

    </template>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import UserViewInfoCardPartOne from './UserViewInfoCardPartOne.vue'
import UserViewInfoCardPartTwo from './UserViewInfoCardPartTwo.vue'
import UserViewActivityTimeline from './UserViewActivityTimeline.vue'
import UserViewStatistics from './UserViewStatistics.vue'

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    UserViewInfoCardPartOne,
    UserViewInfoCardPartTwo,
    UserViewActivityTimeline,
    UserViewStatistics,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  computed: {
    userById() {
      return this.$store.getters.userById(Number(this.id))
    },
  },
  async mounted() {
    await this.loadUserData()
  },
  methods: {
    async loadUserData() {
      if (!this.userById) {
        this.loading = true
        this.error = null

        try {
          await this.$store.dispatch('getUserById', this.id)

          if (!this.userById) {
            this.error = 'Benutzer konnte nicht gefunden werden.'
          }
        } catch (error) {
          console.error('Error loading user:', error)
          this.error = 'Fehler beim Laden der Benutzerdaten. Bitte versuchen Sie es erneut.'
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.alert {
  border-radius: 0.375rem;
}

// Ensure proper spacing for tab content
::v-deep .tab-content {
  .tab-pane {
    border: none;
    padding: 0;
  }
}

// Custom button hover effects
.btn:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease;
}
</style>
